import { put } from "redux-saga/effects";
import { Client } from "../../../../utils/transport";
import {
  ReportsDailyAttendanceSuccess,
  ReportsDailyAttendanceFailed,
  ReportsDownloadDailyAttendanceSuccess,
  ReportsDownloadDailyAttendanceFailed,
  fetchExternalPunchEventsSuccess,
  fetchExternalPunchEventsFailed,
} from "./action";
import { SOMETHING_WENT_WRONG } from "constants/staticText";

export function* GetReportsDailyAttendance(data) {
  let config = {
    method: "POST",
    url: "query/reports/daily_attendance_details",

    headers: {
      // Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ` + data.token,
    },
    data: data.bodyData,
    fetchPolicy: "no-cache",
  };

  try {
    var response = yield Client.request(config);

    if (response.status === 200) {
      yield put(ReportsDailyAttendanceSuccess(response.data));
    } else {
      yield put(ReportsDailyAttendanceFailed(response));
    }
  } catch (err) {
    yield put(ReportsDailyAttendanceFailed(err));
  }
}

export function* GetReportsDownloadDailyAttendance(data) {
  let config = {
    method: "POST",
    url: "query/reports/daily_attendance_details",

    headers: {
      // Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ` + data.token,
    },
    data: data.bodyData,
    fetchPolicy: "no-cache",
  };

  try {
    var response = yield Client.request(config);

    if (response.status === 200) {
      yield put(ReportsDownloadDailyAttendanceSuccess(response.data));
    } else {
      yield put(ReportsDownloadDailyAttendanceFailed(response));
    }
  } catch (err) {
    yield put(ReportsDownloadDailyAttendanceFailed(err));
  }
}

export function* fetchExternalPunchEventsSaga(action) {
  const config = {
    method: "POST",
    url: `query/reports/ext_punch_events`,
    headers: {
      ...action.payload.headers,
    },
    data: { ...action.payload.body },
  };

  try {
    const response = yield Client.request(config);
    yield put(fetchExternalPunchEventsSuccess(response.data?.data || []));
  } catch (err) {
    let errorMessage = SOMETHING_WENT_WRONG;
    if (err.response?.status < 500) {
      errorMessage = err.response?.data?.errors?.[0]?.detail;
    }
    yield put(fetchExternalPunchEventsFailed(errorMessage));
  }
}
